export enum EvaluationScores {
  BelowExpectations = 1,
  ApproachingExpectations = 2,
  MeetsExpectations = 3,
  ExceedsExpectations = 4,
}
